import { EntityList } from '@/common/entityFramework/entityList/EntityList';

export const McoLedgerList = () => {
  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.progId.precedence = 1;
    fieldToFieldDef.progId.hasName = false;

    fieldToFieldDef.earnedPeriodId.precedence = 3;
    fieldToFieldDef.earnedPeriodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // 3. Amounts
    fieldToFieldDef.dispAmt.precedence = 2002;
    fieldToFieldDef.dueAmt.precedence = 2003;
    fieldToFieldDef.paidAmt.precedence = 2004;
  };

  return <EntityList entity="MCO_LEDGER" augFieldDefs={augFieldDefs} />;
};
